import { IHotelStaticInfo } from '@core/models/HotelStaticInfo/hotelStaticInfo.interface';
import { IStateHotelAvailability } from './hotel-availability/hotelAvailability.reducer';
import { availabilityReducer } from '@store/hotel-availability/hotelAvailability.reducer';
import { ActionReducerMap } from '@ngrx/store';
import {
  GroupExpandableData,
  groupExpandableReducer,
} from '@commons/am-expandable-group/expandable-group.reducer';
import { hotelStaticInfoReducer } from './hotelStaticInfo.reducer';
import {
  IStateDisneyTickets,
  disneyTicketsReducer,
} from './disney-tickets/disneyTickets.reducer';
import {
  appContextReducer,
  AppContextState,
} from '@store/app-context/app-context.reducer';

export interface AppState {
  hotelsAvailability: IStateHotelAvailability;
  groupExpandable: GroupExpandableData;
  hotelStaticInfo: IHotelStaticInfo;
  ticketsState: IStateDisneyTickets;
  appContext: AppContextState;
}

export const appReducer: ActionReducerMap<AppState> = {
  groupExpandable: groupExpandableReducer,
  hotelsAvailability: availabilityReducer,
  hotelStaticInfo: hotelStaticInfoReducer,
  ticketsState: disneyTicketsReducer,
  appContext: appContextReducer,
};
